import { useEffect, useState } from "react";
import { useStore } from "../store/useStore";

const SESSION_KEY = "gh_sl@g";

const ALLOWED_ORIGINS = [
  "http://songjukti.com",
  "https://songjukti.com",
  "http://user.songjukti.com",
  "https://user.songjukti.com",
];

const decodeSessionUser = () => {
  try {
    const encoded = window.localStorage.getItem(SESSION_KEY);
    if (!encoded) return null;
    return JSON.parse(atob(encoded));
  } catch (error) {
    console.error("Failed to decode stored session:", error);
    return null;
  }
};

// Reads the logged-in user from the global store; if the store hasn't
// hydrated yet, falls back to whatever session is stashed in localStorage,
// but only trusts it if it was written by an origin we recognize.
export const useSessionUser = () => {
  const { user, setUser } = useStore();
  const [isLogged, setIsLogged] = useState(!!user?.sopnoid);
  const [isMember, setIsMember] = useState(
    !!(user?.refer && user?.sopnoid && user?.membership)
  );

  useEffect(() => {
    const validLogin = !!user?.sopnoid;
    const validMember = !!(user?.refer && user?.sopnoid && user?.membership);

    setIsLogged(validLogin);
    setIsMember(validMember);

    if (validLogin) return;

    const storedUser = decodeSessionUser();
    if (!storedUser) return;

    const originAllowed = [...ALLOWED_ORIGINS, window.location.origin].includes(
      storedUser?.origin
    );
    const hasValidId = !!storedUser?.sopnoid;

    if (originAllowed && hasValidId) {
      setUser(storedUser);
      setIsLogged(true);
      setIsMember(
        !!(storedUser?.refer && storedUser?.sopnoid && storedUser?.membership)
      );
    } else {
      console.warn("Origin mismatch or invalid stored session — clearing it");
      window.localStorage.removeItem("user");
    }
  }, [user, setUser]);

  return { user, isLogged, setIsLogged, isMember };
};
